import { HStack } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import CanopyButton from '../../../canopy-ui-components/components/CanopyButton/CanopyButton';
import * as ga from '../../../canopy-ui-components/google-analytics';
import { useCurrentColors } from '../../../canopy-ui-components/hooks/UseCurrentColors/UseCurrentColors';
import DeleteMappingsModal from './DeleteMappingsModal';
import EditMappingModal from './EditMappingsModal';

const MappingsAction = ({
    globalProps,
    selectedFlatRows,
    refreshData,
    layoutState,
}: any): any => {
    const currentColors = useCurrentColors();
    const [Mappings, setMappings] = useState<any[]>([]);
    const [showMappingEditModal, setShowMappingEditModal] = useState(false);
    const [showMappingDeleteModal, setShowMappingDeleteModal] = useState(false);
    const handleEditMapping = () => {
        ga.event({
            action: `Portfolio > Documents > Edit`,
        });
        setShowMappingEditModal(true);
    };
    const handleDeleteMapping = () => {
        ga.event({
            action: `Portfolio > Documents > Delete`,
        });
        setShowMappingDeleteModal(true);
    };
    useEffect(() => {
        setMappings(selectedFlatRows.map((row: any) => row.original.id));
    }, [selectedFlatRows]);
    const selectedMappings = selectedFlatRows.map((row: any) => row.original);

    if (Mappings?.length) {
        return (
            <>
                <HStack spacing="15px">
                    <CanopyButton
                        height="30px"
                        minWidth="100px"
                        fontSize="sm"
                        fontWeight="bold"
                        variant="solid"
                        onClick={handleEditMapping}
                        size="sm">
                        {globalProps.t('edit-mappings')}
                    </CanopyButton>
                    <CanopyButton
                        height="30px"
                        minWidth="100px"
                        fontSize="sm"
                        fontWeight="bold"
                        variant="solid"
                        onClick={handleDeleteMapping}
                        size="sm">
                        {globalProps.t('delete')}
                    </CanopyButton>
                </HStack>
                {showMappingEditModal && (
                    <EditMappingModal
                        userId={layoutState?.user_id}
                        data={selectedMappings}
                        showModal={showMappingEditModal}
                        setShowModal={setShowMappingEditModal}
                        refreshData={refreshData}
                        globalProps={globalProps}></EditMappingModal>
                )}
                {showMappingDeleteModal ? (
                    <DeleteMappingsModal
                        data={selectedMappings}
                        showModal={showMappingDeleteModal}
                        setShowModal={setShowMappingDeleteModal}
                        refreshData={refreshData}
                        globalProps={globalProps}></DeleteMappingsModal>
                ) : null}
            </>
        );
    }
    return null;
};
export default MappingsAction;
